<template lang="pug">
.home
  //- img(src='../assets/logo.png')
  HelloPrinta(msg='Welcome to Your Vue.js App')
  //- HelloPrinta(msg='Welcome to Your Vue.js App')
</template>

<script>
// @ is an alias to /src
import HelloPrinta from '@/components/HelloPrinta.vue'

export default {
  name: 'home',
  components: {
    HelloPrinta
  }
}
</script>

<style lang="stylus" >
.home
  // position absolute
  display flex
  flex-direction column
</style>
